import { useState, useEffect } from "react"

import { isBrowser } from "utils/infrastructure/ssg-utils"

export const useIsSSR = () => {
    const [isSSR, setIsSSR] = useState(!isBrowser())

    useEffect(() => {
        setIsSSR(false)
    }, [])

    return isSSR
}
